export const vertexShader = /* glsl */ `

varying vec3 vDirection;

void main()
{
    vec4 worldPosition =
        modelMatrix *
        vec4(position, 1.0);

    vDirection =
        normalize(
            worldPosition.xyz -
            cameraPosition
        );

    gl_Position =
        projectionMatrix *
        viewMatrix *
        worldPosition;
}

`;
